import React, { useEffect, useRef } from 'react';

const CursorTrail = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    // Create container for trails
    const container = document.createElement('div');
    container.className = 'fixed inset-0 pointer-events-none z-50';
    document.body.appendChild(container);
    containerRef.current = container;

    const createTrail = (e) => {
      // Get the actual position relative to the viewport
      const x = e.clientX;
      const y = e.clientY;

      // Create trail element
      const trail = document.createElement('div');
      trail.className = 'absolute w-2 h-2 bg-fuckpepe-fire rounded-full opacity-50 transform -translate-x-1/2 -translate-y-1/2 animate-trail';
      trail.style.left = `${x}px`;
      trail.style.top = `${y}px`;
      
      // Append to our fixed container instead of body
      containerRef.current.appendChild(trail);

      // Remove after animation
      setTimeout(() => {
        if (containerRef.current && containerRef.current.contains(trail)) {
          containerRef.current.removeChild(trail);
        }
      }, 1000);
    };

    // Handle iframe interactions
    const handleIframeMouseEnter = () => {
      if (containerRef.current) {
        containerRef.current.style.display = 'none';
      }
    };

    const handleIframeMouseLeave = () => {
      if (containerRef.current) {
        containerRef.current.style.display = 'block';
      }
    };

    // Add event listeners
    window.addEventListener('mousemove', createTrail);
    
    // Find the iframe and add mouse enter/leave handlers
    const iframe = document.querySelector('iframe');
    if (iframe) {
      iframe.addEventListener('mouseenter', handleIframeMouseEnter);
      iframe.addEventListener('mouseleave', handleIframeMouseLeave);
    }

    // Cleanup
    return () => {
      window.removeEventListener('mousemove', createTrail);
      if (iframe) {
        iframe.removeEventListener('mouseenter', handleIframeMouseEnter);
        iframe.removeEventListener('mouseleave', handleIframeMouseLeave);
      }
      if (containerRef.current) {
        document.body.removeChild(containerRef.current);
      }
    };
  }, []);

  return null;
};

export default CursorTrail;